import { useNavigate } from 'react-router-dom'
import { Button } from '../../../components/button'
import { SelectProductModal } from '../../../components/modal/app_modals/selectProductModal'
import { ProductTileContainer } from '../../../components/product/productTile'
import { HeaderSubheader } from '../../../components/typography/HeaderSubheader'
import { useModalControl } from '../../../hooks/useModalControl'
import { useEditSubCategoryMutation } from '../../../redux-toolkits/products/products.slice'
import { Product } from '../../../redux-toolkits/products/products.type'

/** The bundle shown at the top of this subcategory on every storefront. */
export const SubCategoryFeaturedBundle = ({
  subCategoryId,
  bundle,
}: {
  subCategoryId: string
  bundle?: Product | null
}) => {
  const navigate = useNavigate()
  const { modal, modalOpen, setModalOpen, handleModalOpen, handleModalClose } =
    useModalControl()
  const [editSubCategory, { isLoading }] = useEditSubCategoryMutation()

  const save = (featuredBundle: string | null) =>
    editSubCategory({ id: subCategoryId, payload: { featuredBundle } })

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <HeaderSubheader
          title="Featured bundle"
          titleClassName="!font-bold"
          text="Shown at the top of this subcategory on every storefront"
        />
        <Button
          type="button"
          primary
          size="medium"
          className="max-w-fit"
          label={bundle ? 'Change bundle' : 'Choose bundle'}
          loading={isLoading}
          disabled={isLoading}
          onClick={() => handleModalOpen('featuredBundleModal')}
        />
      </div>

      {bundle ? (
        <ProductTileContainer
          products={[bundle]}
          canDelete
          onDeleteProduct={() => void save(null)}
          onViewProduct={(product) => navigate(`/products/view/${product._id}`)}
        />
      ) : (
        <p className="text-sm text-sec-black">No featured bundle yet.</p>
      )}

      <SelectProductModal
        open={modal === 'featuredBundleModal' && modalOpen}
        setOpen={setModalOpen}
        onCloseCallback={handleModalClose}
        maxSelection={1}
        selectedProducts={bundle ? [bundle] : []}
        query={{ isBundleProduct: true }}
        onSuccessCallback={(products) => {
          void save(products[0]?._id ?? null)
          handleModalClose()
        }}
      />
    </div>
  )
}
